import { defineStore } from "pinia";
import { computed, ref } from "vue";
/**
 * This store allows for pointing scoped stores to other scoped stores
 */
export const useScopePointerStore = defineStore("scopePointerStore", () => {
    const scopePointers = ref({});
    function addScopePointer(from, to) {
        scopePointers.value[from] = scope.value(to);
    }
    const scope = computed(() => (scopeId) => scopePointers.value[scopeId] ?? scopeId);
    function removeScopePointer(id) {
        scopePointers.value[id] = undefined;
    }
    return {
        addScopePointer,
        removeScopePointer,
        scope,
    };
});
